module.exports = "<app-title-bar></app-title-bar>\n<div class=\"container\">\n  <div class=\"row\" row vertical-center-row>\n  \t<div class=\"text-center\">\n    \t<router-outlet></router-outlet>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main